import React, { useState } from "react";
import { IVideoTreatment, IVideoTreatmentDetail } from "types/treatment";
import { Modal } from "antd";
import { DownloadOutlined } from '@ant-design/icons';
import s from './s.module.less';
import { isImage } from "components/Prescriptions/components/AttachFiles";
import { sanitizeRichHtml } from 'utils/sanitize';
import PrescriptionCard from "components/PrescriptionCard";
import { useDownloadImage } from "hooks/useDownloadImage";
import { useDownloadFile } from "hooks/useDownloadFile";
import { TextVisitAttachment } from "types/textVisit";

interface PreviewModalProps {
    showPreviewModal: boolean;
    onClose: () => void;
    currentPlan: IVideoTreatment;
    caseData: IVideoTreatmentDetail;
}

const PreviewModal = ({ showPreviewModal, onClose, currentPlan, caseData }: PreviewModalProps) => {
    const attachments = currentPlan?.attachments || [];
    const [imageModalVisible, setImageModalVisible] = useState(false);
    const [currentImage, setCurrentImage] = useState<TextVisitAttachment>();
    const downloadImage = useDownloadImage();
    const downloadFile = useDownloadFile();

    const handleDownloadImage = () => {
        if (currentImage?.previewUrl) {
            downloadImage(currentImage.previewUrl, currentImage.name || 'image');
        }
    };

    return (
        <>
            <Modal open={showPreviewModal} onCancel={onClose} footer={null} width={870} title="Patient view">
                <div className={s.treatmentPlan}>
                    {/* Response Section */}
                    <div className={s.section}>
                        <div className={s.sectionTitle}>Response</div>
                        <div className={s.responseContent}>
                            <div dangerouslySetInnerHTML={{ __html: sanitizeRichHtml(currentPlan?.treatmentPlan || '') }} />
                            {attachments.length > 0 ? (
                                <div className={s.attachments}>
                                    {currentPlan?.attachments.map((attachment, index) => (
                                        <div key={index} className={s.attachmentItem}>
                                            {isImage(attachment) ? (
                                                <div className={s.attachmentPreview} onClick={() => {
                                                    setImageModalVisible(true);
                                                    setCurrentImage(attachment);
                                                }}>
                                                    <img src={attachment.previewUrl || ''} alt={attachment.name} className={s.filePreviewImage} />
                                                </div>
                                            ) : (
                                                <div className={s.fileInfo} onClick={() => downloadFile(attachment.previewUrl || '', attachment.name)}>
                                                    <div className={s.fileName}>
                                                        {attachment.name || ''}
                                                    </div>
                                                    <div className={s.fileType}>
                                                        {attachment.type ? attachment.name?.split('.').pop()?.toUpperCase() : 'Unknown type'}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ) : null}
                        </div>
                    </div>

                    {/* Prescription Section */}
                    {caseData.prescriptions && caseData.prescriptions.length > 0 && (
                        <div className={s.section}>
                            <div className={s.sectionTitle}>Prescription</div>
                            <div className={s.prescriptionCards}>
                                {caseData.prescriptions.map((prescription, index) => (
                                    <PrescriptionCard key={index} prescription={prescription} />
                                ))}
                            </div>
                        </div>
                    )}

                </div>
            </Modal>
            <Modal
                open={imageModalVisible}
                onCancel={() => setImageModalVisible(false)}
                footer={null}
                width="80%"
                centered
                closeIcon={null}
                title={
                    <div className={s.imageModalHeader}>
                        <div className={s.imageModalActions} onClick={handleDownloadImage}>
                            <DownloadOutlined />
                        </div>
                    </div>
                }
            >
                <div className={s.imageContainer}>
                    <img
                        src={currentImage?.previewUrl || ''}
                        alt="ID Document"
                        className={s.previewImage}
                    />
                </div>
            </Modal>
        </>
    );
};

export default PreviewModal;